import { BsFillChatDotsFill, BsPeopleFill } from "react-icons/bs";
import { CHAT_URL } from "../../../../config/app-config";
import dummyImage from "../../assets/img/default_avatar.jpg"; // update path accordingly


function GroupListItem({ group, onOpenChat, onShowGroupMembers  }) {
  return (
    <div className="conversation-list-item position-relative">
      {console.log("GroupListItem group:", group.groupImage)}
      {/* Group Image */}
      <img
         src={`${CHAT_URL}api/getImage/${group.groupImage}`}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = dummyImage;
                    }}
        alt="Group"
        className="conversation-user-avatar"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          objectFit: "cover",
          marginRight: "15px",
        }}
      />

      <div className="conversation-user-name-details" style={{ flex: 1 }}>
        <div
          className="conversation-user-name-container"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
        
          <h3 className="conversation-user-name" style={{ margin: 0 }}>
            {group.name}
          </h3>
          <div style={{ display: "flex", gap: "10px" }}>
            {/* 💬 Chat Icon */}
            <BsFillChatDotsFill
              title="Start Conversation"
              onClick={() => onOpenChat(group)}
              style={{ cursor: "pointer", fontSize: "18px" }}
            />

            {/* 👥 Member List Icon */}
            <BsPeopleFill
              title="View Members"
              onClick={() => {
                onShowGroupMembers(group);
              }}
              style={{ cursor: "pointer", fontSize: "18px" }}
            />
          </div>
        </div>

        <p
          className="conversation-last-message"
          style={{ color: "#898989", fontSize: "13px" }}
        >
          {group.members.length} member
          {group.members.length > 1 ? "s" : ""}
        </p>
      </div>
    </div>
  );
}

export default GroupListItem;
